import global from 'Global';
import { joinUri } from 'UriUtils';
import versionedContentLookup from 'VersionedContentLookup';

export default function versionedContent(relativePath) {
	const upperCased = relativePath.toUpperCase();
	const resourceValue = versionedContentLookup[upperCased] || relativePath;
	return joinUri(global.rootPath, resourceValue);
}
